import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import CustomLink from '../CustomLink';
import { uiConfig } from '../../app-ui-config';
import styles from './Logo.css';

const cx = classnames.bind(styles);

function Logo({ className, onClick, url, inApp }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <CustomLink
            to={url}
            className={classes}
            onClick={onClick}
        >
            <img
                src={inApp ? uiConfig.logo : uiConfig.logoWhite}
                alt={uiConfig.name}
            />
        </CustomLink>
    );
}

Logo.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    url: PropTypes.string,
    inApp: PropTypes.bool
};

Logo.defaultProps = {
    onClick: null,
    className: '',
    url: '/',
    inApp: false
};

export {
    Logo
};
